import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

import { assetURL } from "lib/utilities/asset";

import "styles/css/Loading.scss";

const AddressesPopup = new Popup({
	title: () => "",
	closeable: false,
	distinct: true,
	style: {minWidth: 100},
	render: function() {
		const message:string = this.get("message") || "";
		
		return (
			<>
				<div className="loading-contents">
					<img src={assetURL("assets/images/spinner.gif")} />
					{message != "" ? <p>{message}</p> : null}
				</div>
			</>
		)
	}
});

export default AddressesPopup;